import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Axios instance that sends cookies for admin endpoints
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});
